import * as React from 'react';
import {MeetingObj} from '../../Entity/Objmeeting';
import  './Report.scss';
import Moment from 'react-moment';

import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { DirectionalHint, IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
//import ReactHtmlParser from 'react-html-parser';
import HTMLReactParser from 'html-react-parser';
export interface IProps{
  meeting: MeetingObj; 
  Phrases;
}
export interface IContextualMenuState {
    DetailCalloutVisible?: boolean;
    beakWidth?: number;
}
export default class ReportDetailView extends React.Component<IProps,IContextualMenuState,IContextualMenuItem>{
  /*state: IProps = {
   
  };*/
  
  private _menuButtonElement: HTMLElement | null;
  constructor(props: IProps) {
    super(props);  
    this.state = {      
      DetailCalloutVisible:false,
      beakWidth: 16
    }; 
  }
  public render() {
    const { DetailCalloutVisible,beakWidth } = this.state;
    let rowcss="ms-Grid-row miparow";
    
    let satisfactions=[' ','😡', '😞', '😐', '🙂', '😃'];
    let economictendency={
        'Very bad':(<span>
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
            </span>),
        'Bad':(<span>
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
        </span>),
        'Good':(<span>
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
        </span>),
        'Very good':(<span>
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStar" />
        </span>),
        'Excelent':(<span>
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
                <i className="ms-Icon ms-Icon--FavoriteStarFill economicsatisfaction" />
        </span>)

    };
    return (
        <div className='crmreport'>
            <span style={{cursor:'pointer'}} ref={menuButton => (this._menuButtonElement = menuButton)} onClick={this._onMenuClicked} title={this.props.meeting.Subject} className='ellips'>{this.props.meeting.Subject}
            {DetailCalloutVisible ? (
                        <Callout
                                
                                className="ms-Callout-callout"
                                onDismiss={this._onCalloutDismiss}
                                target={this._menuButtonElement}
                                directionalHint={DirectionalHint.topAutoEdge}
                                coverTarget={false}
                                isBeakVisible={true}
                                gapSpace={0}
                                beakWidth={beakWidth}
                              >
                            <div className='detailcallout'>
                                <div className={["ms-Callout-header",'ellips'].join(' ')} style={{background:'#F8E6CE',padding:'10px',fontWeight:'bold',fontSize:'18px'}}>
                                {this.props.meeting.Subject}
                                </div>
                                <div className="ms-Callout-inner" style={{padding:'10px'}}>
                                    <div className="ms-Callout-content ms-Grid">
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.contacttype} :</div>
                                                <div className="ms-Grid-col ms-sm8">{this.props.meeting.ContactType}</div>
                                            </div>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.reportdate} :</div>
                                                <div className="ms-Grid-col ms-sm8"><Moment  format="DD MMM YYYY">{this.props.meeting.ReportDate}</Moment></div>
                                            </div>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.followupdate} :</div>
                                                <div className="ms-Grid-col ms-sm8"><Moment  format="DD MMM YYYY">{this.props.meeting.Followup}</Moment></div>
                                            </div>
                                            <hr></hr>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.company} :</div>
                                                <div className="ms-Grid-col ms-sm8">{this.props.meeting.Company}</div>
                                            </div>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.contact} :</div>
                                                <div className="ms-Grid-col ms-sm8">{this.props.meeting.Contact}</div>
                                            </div>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.additionalcontact} :</div>
                                                <div className="ms-Grid-col ms-sm8">{HTMLReactParser(this.props.meeting.AdditionalContactDisplay)}</div>
                                            </div>
                                            <hr/>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm4 detaillable">{this.props.Phrases.summary} :</div>
                                                <div className="ms-Grid-col ms-sm8">
                                                    <div className="summaryindetail">
                                                        {this.props.meeting.Summary}
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                            <hr/>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm6 detaillable">{this.props.Phrases.customersatisfaction} :</div>
                                                <div className="ms-Grid-col ms-sm6" style={{fontSize:'18px'}}>
                                                {this.props.meeting.CustomerSatisfacitonTendency=='Negetive'?
                                                    (<span className="trendnegative">👎</span>):
                                                    (<span className="trendpossitive">👍</span>)
                                                }
                                                <span>{satisfactions[parseInt(this.props.meeting.CustomerSatisfaction)]}</span>
                                                
                                                </div>
                                            </div>
                                            <div className={rowcss}>
                                                <div className="ms-Grid-col ms-sm6 detaillable">{this.props.Phrases.economictrends} :</div>
                                                <div className="ms-Grid-col ms-sm6" style={{fontSize:'18px'}}>
                                                {this.props.meeting.EconomicTendency=='Negetive'?
                                                    (<span className="trendnegative">👎</span>):
                                                    (<span className="trendpossitive">👍</span>)
                                                }
                                                {economictendency[this.props.meeting.EconomicTrend]}
                                                </div>
                                            </div>
                                    </div>                               
                                </div>
                            </div>
                        </Callout>
        ) : null} 
            </span>
            
        </div>
    );
  }
  

  private _onCalloutDismiss = (): void => {
    this.setState({
      DetailCalloutVisible: false
    });
  }

  private _onMenuClicked = (): void => {
    this.setState({
      DetailCalloutVisible: !this.state.DetailCalloutVisible
    });
  }
}
